<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-card>
        <div class="d-flex mx-7 pt-5 justify-space-between">
          <h5 class="text-h5">Data Testimoni</h5>
          <v-btn v-if="!isEdit" density="compact" @click="isEdit = true"
            >Edit <v-icon class="ml-1">mdi-pen</v-icon></v-btn
          >
        </div>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentData.judul"
                  :disabled="!isEdit"
                  label="Judul"
                  clearable
                  dense
                  outlined
                  required
                ></v-text-field>
                <v-combobox
                  v-model="currentData.selectedHide"
                  :disabled="!isEdit"
                  label="Publish"
                  dense
                  outlined
                  :items="currentData.items_hide"
                  item-text="name"
                ></v-combobox>
                <v-file-input
                  v-model="filefoto"
                  :disabled="!isEdit"
                  label="Upload Foto"
                  accept="image/*"
                  prepend-icon="mdi-image"
                  clearable
                  dense
                  outlined
                  @change="loadImage"
                >
                </v-file-input>
                <v-row v-if="currentData.FotoUrl" class="my-5">
                  <v-col cols="12" sm="6" md="4">
                    <v-responsive :aspect-ratio="16 / 9">
                      <v-img :src="currentData.FotoUrl" contain></v-img>
                    </v-responsive>
                  </v-col>
                </v-row>
                <v-textarea
                  v-model="currentData.konten"
                  :disabled="!isEdit"
                  label="Konten"
                  clearable
                  dense
                  outlined
                  required
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- Start Gallery  -->
            <div v-if="isEdit">
              <CardGallery />
            </div>
            <!-- End Gallery  -->
          </v-container>
        </v-card-text>
        <div style="height: 60px"></div>
        <v-card-actions v-if="isEdit">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="isEdit = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import { reactive } from "vue";
// import { quillEditor } from "vue3-quill";
import CommonService from "../../services/CommonService";
import TestimoniService from "../../services/web_content/TestimoniService";
import CardGallery from "../../components/CardGallery.vue";

export default {
  name: "App",
  components: {
    // quillEditor,
    CardGallery,
  },
  setup() {
    const state = reactive({
      content: "",
      _content: "",
      editorOption: {
        placeholder: "Tulis konten di sini..",
        modules: {},
      },
      disabled: false,
    });
    return {
      state,
    };
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Testimoni",
        disabled: false,
        href: "/webcontent/testimoni",
      },
      {
        text: "Edit Testimoni",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    isEdit: false,
    filefoto: null,
    currentData: {
      id: "",
      judul: "",
      selectedHide: "",
      konten: null,
      foto_url: "",
      FotoUrl: "",
      items_hide: [
        { code: 1, name: "Publish" },
        { code: 2, name: "Hide" },
      ],
    },
  }),
  mounted() {
    this.getData();
  },
  methods: {
    loadImage: function (data) {
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.currentData.FotoUrl = e.target.result;
        };
        reader.readAsDataURL(data);
      } else {
        this.currentData.FotoUrl = "";
        this.currentData.foto_url = null;
      }
    },
    getData() {
      const data = sessionStorage.getItem("item_testimoni");
      const testimoni = JSON.parse(data);
      console.log(testimoni);
      this.currentData.id = testimoni.id;
      this.currentData.judul = testimoni.title;
      this.currentData.konten = testimoni.testimoni;
      this.state._content = testimoni.testimoni;
      this.state.content = testimoni.testimoni;
      this.currentData.FotoUrl = testimoni.foto_url;

      this.currentData.items_hide.forEach((entry) => {
        if (entry.code == testimoni.data_status) {
          this.currentData.selectedHide = entry;
        }
      });
    },
    doSave: async function () {
      if (this.currentData.judul == "" || this.currentData.konten == null) {
        CommonService.showWarningToast("Lengkapi data terlebih dahulu!");
      } else {
        TestimoniService.update(
          this.currentData,
          this.currentData.konten,
          this.filefoto,
        )
          .then(() => {
            CommonService.showSuccessToast("update testimoni berhasil");
            this.$router.push("/webcontent/testimoni");
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("update testimoni gagal. Coba lagi");
          });
      }
    },
  },
};
</script>
